
const questions = [

    {
        id: 1,
        title: 'Is there a database?',
        info: 'There is no data yet. Site is front-end only so far.',
    },

    {
        id: 2,
        title: 'Are there cookies?',
        info: 'No... except in the cookie jar.',
    },

    {
        id: 3,
        title: 'When will the site be full-stack?',
        info: 'Aiming for Summer 2023.',
    }

]

export default questions 